export const DEFAULT_CONFIG = {
  TASK_END_DATE_OFFSET_HOURS: 24,
  MEETING_DURATION_OPTIONS: [
    { value: 0.25, labelKey: "duration.15minutes" },
    { value: 0.5, labelKey: "duration.30minutes" },
    { value: 1, labelKey: "duration.1hour" },
    { value: 2, labelKey: "duration.2hours" },
    { value: 3, labelKey: "duration.3hours" },
    { value: 24, labelKey: "duration.1day" },
  ],
};

export type AppEnv = "test" | "prod";

export const APP_ENV = (process.env.REACT_APP_ENV ?? "test") as AppEnv;

export const API_HOSTS: Record<AppEnv, string> = {
  test: "https://crm.smarstech.dev",
  prod: "https://crm.smarstech.net",
};

/** Dev: direct CRM. Build: relative /api/v1 (reverse proxy on app host). */
export const API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? `${API_HOSTS[APP_ENV]}/api/v1`
    : "/api/v1";
